import { render } from "./DemandForecastingPage.vue?vue&type=template&id=216ed1ac&scoped=true"
import script from "./DemandForecastingPage.vue?vue&type=script&lang=js"
export * from "./DemandForecastingPage.vue?vue&type=script&lang=js"

import "./DemandForecastingPage.vue?vue&type=style&index=0&id=216ed1ac&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-216ed1ac"]])

export default __exports__